import React, { useState, useEffect } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { getter } from "@progress/kendo-react-common";
import { loadClientUserGridData } from "../../../handlers/ClientDetail/GridApiCall";

import useReloadButton from "../../../CustomHooks/useReloadButton";
import { useKendoGridHandlers } from "../../../CustomHooks/useKendoGridHandlers";

const DATA_ITEM_KEY = "EMAIL";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

export const DEFAULT_GRID_INFO_CLIENT_USER = {
  action: "LOADUSERS",
  className: "USER",
  pageSize: 20,
  currentPageNumber: 1,
  sortName: "EMAIL",
  sortOrder: "desc",
  gridHeight: "300px",
};

const PAGER_SETTINGS = {
  info: true,
  type: "input",
  previousNext: true,
  pageSize: 4,
  refresh: true,
};

const KendoClientDetailUser = (props) => {
  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(0);
  const [reloadToggle, setReloadToggle] = useState(false);

  const [gridState, setGridState] = useState({
    pageNumber: DEFAULT_GRID_INFO_CLIENT_USER.currentPageNumber,
    pageSize: DEFAULT_GRID_INFO_CLIENT_USER.pageSize,
    sortName: DEFAULT_GRID_INFO_CLIENT_USER.sortName,
    sortOrder: DEFAULT_GRID_INFO_CLIENT_USER.sortOrder,
    sort: [
      {
        field: DEFAULT_GRID_INFO_CLIENT_USER.sortName,
        dir: DEFAULT_GRID_INFO_CLIENT_USER.sortOrder?.toLowerCase() || "asc",
      },
    ],
  });

  const { HandleDataStateChange, HandlePageChange } =
    useKendoGridHandlers(setGridState);

  const [selectedState, setSelectedState] = React.useState();

  // UseEffect to load the grid data
  useEffect(() => {
    loadClientUserGridData(props?.clientId, gridState).then((response) => {
      setGridData(response.rows);
      setTotal(response.total);
    });
  }, [gridState, reloadToggle]);

  useReloadButton(setReloadToggle);
  const SelectedContentLength = () => {
    const selectedText = window.getSelection().toString();
    return selectedText.length > 0;
  };

  const onSelectionChange = React.useCallback(
    (event) => {
      const check = SelectedContentLength();
      if (!check) {
        const newSelectedState = getSelectedState({
          event,
          selectedState,
          dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);
      }
    },
    [selectedState]
  );

  const ActiveUser = (props) => {
    if (
      props.dataItem.ACTIVE_FLAG &&
      props.dataItem.ACTIVE_FLAG.toUpperCase() === "Y"
    ) {
      return <td className="pl-4">Yes</td>;
    } 
      return <td className="pl-4">No</td>;
    
  };

  return (
    <div>
      <Tooltip openDelay={100} position="right" anchorElement="target">
        <Grid
          style={{ height: "calc(100vh - 217px)" }}
          scrollable="scrollable"
          total={total}
          skip={(gridState.pageNumber - 1) * gridState.pageSize}
          pageSize={gridState.pageSize}
          filterable={false}
          sortable={{
            mode: "single",
            allowUnsort: false,
          }}
          sort={gridState.sort}
          selectedField={SELECTED_FIELD}
          data={gridData.map((item) => ({
            ...item,
            [SELECTED_FIELD]: selectedState?.[idGetter(item)] || false,
          }))}
          selectable={{
            enabled: true,
            drag: false,
            cell: false,
            mode: "multiple",
          }}
          pageable={PAGER_SETTINGS}
          onPageChange={HandlePageChange}
          onDataStateChange={HandleDataStateChange}
          onSelectionChange={onSelectionChange}
        >
          <GridColumn title="User Name" field="EMAIL" />
          <GridColumn title="First Name" field="FIRST_NAME" />
          <GridColumn title="Last Name" field="LAST_NAME" />
          <GridColumn
            title="Active"
            field="ACTIVE_FLAG"
            cell={ActiveUser}
            sortable
            width={150}
          />
        </Grid>
      </Tooltip>
    </div>
  );
};
export default KendoClientDetailUser;
